<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('cdn.domain')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						<el-form-item label="上级推流" class="mb-0">
							<el-select v-model="from.tl" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" value="">
								</el-option>
								<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain " :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<!-- <el-form-item :label="$t('accountList.ac_id')" class="mb-0">
							<el-input size="small" v-model="from.ac_id"></el-input>
						</el-form-item>
						<el-form-item :label="$t('adminList.loginName')" class="mb-0">
							<el-input size="small" v-model="from.username"></el-input>
						</el-form-item> -->
						
						
						<el-form-item :label="$t('live.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('live.type1')" :value="1"></el-option>
								<el-option :label="$t('live.type2')" :value="2"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('live.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('live.status1')" :value="1"></el-option>
								<el-option :label="$t('live.status2')" :value="0"></el-option>
								
							</el-select>
						</el-form-item>
						
						
						<!-- <el-form-item :label="$t('accountList.getType')" class="mb-0">
							<el-select v-model="from.get_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.noGet')" :value="0"></el-option>
								<el-option :label="$t('accountList.yesGet')" :value="1"></el-option>
								<el-option :label="$t('accountList.expireGet')" :value="2"></el-option>
								
							</el-select>
						</el-form-item> -->
						
						<!-- <el-form-item :label="$t('accountList.account_status')" class="mb-0">
							<el-select v-model="from.account_status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.zc')" :value="1"></el-option>
								<el-option :label="$t('accountList.yc')" :value="0"></el-option>
								<el-option :label="$t('accountList.dy')" :value="2"></el-option>
								<el-option :label="$t('accountList.zf')" :value="3"></el-option>
								
							</el-select>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						
						
						<!-- <el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item> -->
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					 <!-- <div class="key-row" >
					     <div class="key-left">
					       <div class="label">{{$t('live.nowkey')}}：</div>
					 
					       <div class="key-box" :title="nowKey">
					         <span v-if="nowKeyStatus" class="key-value">{{ nowKey }}</span>
					         <span v-else class="key-hidden">{{ nowKey ? hiddenMask : '未设置' }}</span>
					       </div>
					 
					       <el-tooltip :content="$t('live.hideshowKey')" placement="top">
					         <button class="icon-btn" @click="toggleNowKey" :aria-label="$t('live.hideshowKey')">
					           <i class="el-icon-view icon-view"></i>
					         </button>
					       </el-tooltip>
					 
					       <el-tooltip :content="$t('live.copyKey')" placement="top">
					         <button class="icon-btn" @click="copyText(nowKey)" :aria-label="$t('live.copyKey')">
					           <i class="iconfont icon-fuzhi icon-copy"></i>
					         </button>
					       </el-tooltip>
					 
					       <el-button size="mini" type="primary" class="btn-edit" @click="openEditKey">{{$t('cdnd.edit')}}</el-button>
					     </div>
					 
					     <div class="key-right">
					       <div class="small-label">{{$t('live.use_time')}}：</div>
					       <el-tag size="small" effect="plain" class="time-tag">
					         {{ nowKeyTime ? nowKeyTime : $t('live.noUse') }}
					       </el-tag>
					     </div>
					   </div> -->
					
					
					
			</template>
			
			<div style="margin-top:10px">
				<el-button size="small" v-if="layout.user.type==1" @click="applyRuleModel = true" v-auth="'add'+auth_val" >{{$t('match.applyDomain')}}</el-button>
			</div>
		</div>
		
		


		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table
				:data="tableData"
				style="width: 100%"
				row-key="id"
				:tree-props="{ children: 'children' }"
				:row-class-name="getLiveDomainRowClass"
				@selection-change="handleSelectionChange">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				<el-table-column fixed="left" align="center" label="播放" width="60">
				</el-table-column>
				
				<!-- <el-table-column fixed="left" align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column> -->
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				<el-table-column  show-overflow-tooltip="" width="200" align="center" prop="domain" :label="$t('cdn.domain')">
				</el-table-column>
				
				
				<!-- <el-table-column  align="center" prop="cname" label="CNAME">
					<template slot-scope="scope">
						
					<i class="el-icon-warning-outline mr-1" :class="scope.row.cname_status==1?'text-success':'text-danger'"  style="font-size: 18px;"></i>	
					<el-tooltip class="item" effect="light" :content="scope.row.cname" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.cname }}</span>
					 
					</el-tooltip>
					
					
					<span class="iconCopy" @click="copyText(scope.row.cname)"><i class="iconfont icon-fuzhi"></i></span>
					</template>
				</el-table-column> -->
				
				<el-table-column align="center"  prop="type" :label="$t('live.type')">
					<template slot-scope="scope">
						
						<el-tag  v-if="scope.row.type==1" type="success">{{$t('live.type1')}}</el-tag>
						<el-tag v-if="scope.row.type==2" type="info">{{$t('live.type2')}}</el-tag>
						
						
						
					</template>
				</el-table-column>
				
				
				
				
				
				<!-- <el-table-column width="120" align="center" prop="cloud_name" :label="$t('live.cloud')">
				</el-table-column> -->
				
				
				
				
				
				
				
				
					
						
				
				
							
				
				
			
				
				
				<!-- <el-table-column align="center" width="140" prop="user_name" :label="$t('accountList.getUser')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				 -->
				
				
				<el-table-column align="center" width="100"  prop="type" :label="$t('live.up_regoin')">
					<template slot-scope="scope">
						
						<span v-if="scope.row.up_regoin==1">{{$t('live.ChineseMainland')}}</span>
						<span v-if="scope.row.up_regoin==2">{{$t('live.Global')}}</span>
						<span v-if="scope.row.up_regoin==3">{{$t('live.gaAndAbroad')}}</span>

				
					</template>
				</el-table-column>
			
				
				<el-table-column min-width="240" show-overflow-tooltip="" align="center"  prop="bind_domain" :label="$t('live.bindTl')">
					
				</el-table-column>
				
				
				
				
				<el-table-column align="center" width="100" prop="sort" :label="$t('live.status')">
					<template slot-scope="scope">
						<el-button  
							:type="scope.row.user_status ? 'success' : 'danger'" 
							size="mini"
							@click="changeStatus(scope.row,'user_status')"
							plain>{{scope.row.user_status ? $t('live.status1') : $t('live.status2')}}
						</el-button>
					</template>
				</el-table-column>
							
				<el-table-column align="center" width="100" prop="sort" :label="$t('live.sort')">
				</el-table-column>
				
				
				
				
				
				<el-table-column align="center" width="200" prop="remark" :label="$t('cdn.remark')">
					<template slot-scope="scope">
					<el-tooltip class="item" effect="light" :content="scope.row.user_remark" placement="top" >
					  <span class="ellipsis-text">{{ scope.row.user_remark }}</span>
					 
					</el-tooltip>
					
				
					</template>
				</el-table-column>
				
				
				
			
				
				
				
				<!-- <el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column> -->
				
				<!-- <el-table-column align="center" width="180" prop="get_time" :label="$t('accountList.getTime')">
				</el-table-column> -->
				
				
			
				
		
				<el-table-column :width="layout.user.type==1?190:80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button  @click="toDetail(scope.row)"  size="mini" plain type="success">{{$t('live.guan')}}</el-button>
							<el-button v-if="layout.user.type==1" size="mini" plain type="primary" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('adminList.operation')}}</el-button>
							
							
					<!-- 		<el-button v-if="layout.user.type==1" size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteItem(scope.row)">{{$t('adminList.delete')}}</el-button> -->
							
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('live.editDoamin') : $t('live.editDoamin')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				
				
				<div v-if="editIndex>0">
					<!-- 选择服务商 -->
					<!-- <el-form-item   :label="$t('live.cloud')" prop="cloud_id">
						<el-select   v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item> -->
					
					
					<!-- 选择分配用户 -->
					<!-- <el-form-item v-if="form.type==1"  :label="$t('accountList.getUser')" prop="cloud_id">
						<el-select   v-model="form.uid" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.user" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item> -->
					
					
					<!-- 选择分配用户 -->
					<!-- <el-form-item v-if="form.type==2"  :label="$t('live.bindTl')" prop="cloud_id">
						<el-select   v-model="form.bind_id" size="small" filterable :placeholder="$t('system.select')">
						<el-option  :label="$t('live.nosel')" :value="0">
						</el-option>
							<el-option v-for="item in agentData.tl" :key="item.id" :label="item.domain" :value="item.id">
							</el-option>
						</el-select>
						
					</el-form-item> -->
					
					
					<el-form-item :label="$t('live.sort2')" prop="sort">
						<el-input v-model="form.sort" :placeholder="$t('live.sort2')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
					<el-form-item   :label="$t('live.status')">
						<el-radio-group   v-model="form.user_status" size="small">
							<el-radio :label="1" border>{{$t('live.status1')}}</el-radio>
							<el-radio :label="0" border>{{$t('live.status2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					
				
					
					<el-form-item :label="$t('cdn.remark')" prop="remark">
						<el-input v-model="form.remark" :placeholder="$t('cdn.remark')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
				</div>
				
				
				
				
				
				
				
				
				
				
				
				
			
				
			</el-form>

			<div slot="footer"  class="dialog-footer text-center">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{form.now==0?$t('live.next'):$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		
		<el-dialog :close-on-click-modal="false"
			:title="$t('accountList.editStatusRemark')"
			:visible.sync="remarkModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_remark" ref="form_remark" :model="form_remark" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item :label="$t('accountList.remark')" prop="remark">
					<el-input v-model="form_remark.remark" :placeholder="$t('accountList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="remarkModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitRemark">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>



<el-dialog :close-on-click-modal="false"
			:title="$t('live.editKey')"
			:visible.sync="KeyModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules_key" ref="form_key" :model="form_key" :label-width="layout.is_phone?'80px':'100px'">
		
				
				<el-form-item   :label="$t('live.nowkey')" prop="key">
					<el-input @input="checkKeyInp"  v-model="form_key.key" :placeholder="$t('live.nowkey')" clearable size="small" style="width: 55%;"></el-input>
					<el-link class="ml-3 text-info" type="success"  @click="rangKey(1)">随机生成</el-link>
					
				</el-form-item>
				
				
				
			</el-form>
		
			<div slot="footer" class="dialog-footer">
				<el-button @click="KeyModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitKey">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>
		
		<!-- 申请权限 -->
		<applyRule :applyRuleModel="applyRuleModel" @hide="applyRuleModel=false" :isphone="layout.is_phone" :type="applyRuleType"></applyRule>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	import applyRule from '@/components/api/applyRule.vue';
	export default {
		components: {
			buttonSearch,
			applyRule
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				applyRuleModel:false,
				applyRuleType:'domain',
				KeyModel:false,
				nowKey:'',
				nowKeyTime:'',
				nowKeyStatus:false,
				form_key:{
					key:''
				},
				remarkModel:false,
				createModel: false,
				editIndex: -1,
				
				checkTXT:false,
				//搜索數据
				from: {
					tl:"",
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				},
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/livedomainList", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/delLivedomain", //删除單条地址
				addUrl: "data/addLivedomain", //添加/修改地址
				editStatusUrl:"data/editStatusLivedomain",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				form_remark:{
				},
				rules_remark:{
					remark: [{
						required: true,
						message: this.$t('accountList.inpStatusRemark'),
						trigger: 'blur',
					}],
				},
				rules_key: {
				  key: [
				    {
				      required: true,
				      message: this.$t('live.inpnowkey'),
				      trigger: 'blur',
				    },
				    {
				      len: 32,
				      message: this.$t('live.inpnowkey32'),
				      trigger: 'blur',
				      transform: v => (typeof v === 'string' ? v.trim() : v),
				    },
				  ],
				},
				rules: {
					
					
				},
				rule_list: [],
				check_img_list:[],
				
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
			// 用同样长度的遮掩点 •，比星号更美观
			    hiddenMask() {
			      return '•'.repeat(this.nowKey.length);
			    }
		},
		created() {
			this.commonList('liveDomain');
		},
		methods: {
			getLiveDomainRowClass({ row }) {
				if (row.type == 2 && row.bind_id > 0) {
					return 'live-domain-child-row';
				}
				if (row.type == 1 && row.children && row.children.length) {
					return 'live-domain-parent-row';
				}
				return '';
			},
			submitRemark(){
				
			},
			toggleNowKey() {
			      this.nowKeyStatus = !this.nowKeyStatus;
			    },
			submitKey(){
				this.$refs.form_key.validate(res => {
					
					if (res) {
						this.submitKeyApi()
					}
				})
			},
			
			//公共列表
			submitKeyApi() {
				this.layout.loading = true;
				this.axios.post('/admin/data/editUserKey', this.form_key, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					//console.log(list)
					this.nowKey = this.form_key.key
					
					this.nowKeyTime = list.use_time
					this.$message({
						message: all.msg,
						type: 'success'
					}); // 控制是否顯示成功提示
					this.KeyModel = false
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			openEditKey(){
				this.form_key.key = this.nowKey
				this.KeyModel = true
			},
			
			checkKeyInp(val){
				
				const clean = val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 32);
				this.form_key.key = clean;
			},
			
			rangKey(type){
				const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
				    let key = '';
				    for (let i = 0; i < 32; i++) {
				      key += chars.charAt(Math.floor(Math.random() * chars.length));
				    }
					
					if(type==1){
						this.form_key.key = key
					} 
			},
			
			toDetail(item){
				let commonDetailPage = {}
				commonDetailPage.id = item.id
				commonDetailPage.name = item.domain
				commonDetailPage.type = item.type
				commonDetailPage.page = 'live_domain'
				commonDetailPage.url = 'live_detaildo'
				
				localStorage.setItem('commonDetailPage',JSON.stringify(commonDetailPage));
				this.$router.push({
					name: commonDetailPage.url
				})
			},
			
			
			

			
		
			
			//提交
			submit() {

				this.$refs.form.validate(res => {
					console.log(this.checkTXT)
					console.log(this.form.now)
					if (res) {
						
						if(this.editIndex>0){
							this.form.id = this.editIndex
							this.addOrEdit(this.form)
						}
						
						
					}
				})
			},
			
			
			
			
			// 打开模态框
			openModel(e = false) {
				// 增加
				console.log(e)
				this.checkTXT = false
				if (!e) {
					// 初始化表單
					this.form = {}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						user_status:e.user_status,
						sort:e.sort,
						remark:e.user_remark,
					}
					this.editIndex = e.id
					
				
					
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				let typeval = [type]
				this.axios.post('/admin/user/commonList', {
					type: typeval,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type=='liveDomain'){
						this.agentData = list
					}else{
						this.agentData.tl = list.tl
					}
					
					
					
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.nowKey = e.nowKey
				this.nowKeyTime = e.nowKeyTime
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					tl:'',
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					account_status:-1,
					type:-1,
					cloud_id:-1,
					ac_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}


.model_table .el-table .el-table__cell{
	padding: 0px 0;
}

.live-domain-parent-row > td {
	background-color: #f1fbf3 !important;
}

.live-domain-child-row > td {
	background-color: #f2f7ff !important;
}

.live-domain-parent-row:hover > td {
	background-color: #e6f7ea !important;
}

.live-domain-child-row:hover > td {
	background-color: #e8f2ff !important;
}

.w-other{
	width: 100px;
}
.nn_bor{
	border: 1px solid #ccc;
	width: 90%;
	border-radius: 5px;
}


.key-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  padding: 6px 0;
  border-radius: 6px;
}

/* 左侧：key + 操作 */
.key-left {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.label {
  color: #606266;
  font-size: 14px;
  margin-right: 6px;
}

/* key 的展示框 */
.key-box {
  min-width: 220px;
  max-width: 420px;
  padding: 6px 10px;
  border-radius: 4px;
  background: #fafafa;
  border: 1px solid #ebeef5;
  display: inline-flex;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.key-value {
  font-family: monospace;
  letter-spacing: 1px;
  font-size: 13px;
  color: #303133;
}

.key-hidden {
  font-size: 13px;
  color: #909399;
}

/* 小图标按钮风格 */
.icon-btn {
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.icon-btn:hover {
  background: rgba(0,0,0,0.03);
}
.icon-view {
  font-size: 18px;
  color: #606266;
}
.icon-copy {
  font-size: 16px;
  color: #606266;
}

/* 编辑按钮微调 */
.btn-edit {
  margin-left: 8px;
}

/* 右侧：最近访问时间 */
.key-right {
  display: flex;
  align-items: center;
  gap: 8px;
}

.small-label {
  color: #909399;
  font-size: 13px;
}

.time-tag {
  font-size: 13px;
 
}
</style>
